
<template>
  <div id="entity_stats_by_season" class="border-padding">
  <main>
    <h2 v-if="header != undefined">{{ header }}</h2>
    <div class="row">
      <div class="border-padding col-md-2" v-if="stat_type_dropdown.data != undefined">
        <label class="typo__label">{{ stat_type_dropdown.label }}</label>
          <multiselect
            v-model="stat_type_selected"
            select-label=""
            deselect-label=""
            track-by="id"
            label="text"
            @input="changeStatType"
            :preselect-first="true"
            :options="stat_type_dropdown.data"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
      </div>
      <div v-if="table_data_options.length > 0" class="col-md-2 border-padding">
        <stat-table-select v-model="stat_table_selected" :options="table_data_options"></stat-table-select>
      </div>
    </div>
    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>
    <div v-if="table_data_options.length > 0">
      <div v-if="stat_table_selected != undefined && regular_season_table_data != undefined">
        <div>
          <button type="button" @click="copyDirectLink">Copy Direct Link To Table</button>
        </div>
        <h3>Regular Season</h3>
        <vue-good-table
          :columns="table_columns[stat_table_selected.id]"
          :rows="regular_season_table_data"
          :pagination-options="{ enabled: false}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true, initialSortBy: {field: 'Season', type: 'asc'}}"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Season'">
              <span :id="'rs-popover-' + props.row.Season + '-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                {{props.formattedRow[props.column.field]}}
              </span>
              <b-popover
                :target="'rs-popover-' + props.row.Season + '-' + stat_table_selected.id">
                <template slot="title">{{props.row.Name}}</template>
                <ul>
                  <li v-if="$route.query.EntityType == 'Player'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'player' }, query: {Season: props.row.Season, SeasonType: 'Regular+Season', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Team'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'team' }, query: {Season: props.row.Season, SeasonType: 'Regular+Season', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Opponent'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'opponent' }, query: {Season: props.row.Season, SeasonType: 'Regular+Season', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Lineup'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'lineup' }, query: {Season: props.row.Season, SeasonType: 'Regular+Season', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'LineupOpponent'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'lineup-opponent' }, query: {Season: props.row.Season, SeasonType: 'Regular+Season', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Team'"><router-link :to="{ name: 'assist_networks', params: { type: 'team', league: $route.params.league }, query: { Season: props.row.Season, SeasonType: 'Regular+Season', TeamId: $route.query.EntityId }}">Assist Network</router-link></li>
                  <li v-if="$route.query.EntityType == 'Lineup'"><router-link :to="{ name: 'assist_networks', params: { type: 'lineup', league: $route.params.league }, query: { Season: props.row.Season, SeasonType: 'Regular+Season', LineupId: $route.query.EntityId }}">Assist Network</router-link></li>
                </ul>
              </b-popover>
            </div>
            <div v-else>
              <span v-b-tooltip.hover :title="props.formattedRow['Season']">
                {{props.formattedRow[props.column.field]}}
              </span>
            </div>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>
        <h5>Regular Season - Career</h5>
        <vue-good-table
          :columns="table_columns[stat_table_selected.id]"
          :rows="[regular_season_career_table_data]"
          :sort-options="{ enabled: false}"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.formattedRow[props.column.field] == ''">
              0
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
        <h3>Playoffs</h3>
        <vue-good-table
          :columns="table_columns[stat_table_selected.id]"
          :rows="playoff_table_data"
          :pagination-options="{ enabled: false}"
          :searchOptions="{ enabled: false}"
          :sort-options="{ enabled: true, initialSortBy: {field: 'Season', type: 'asc'}}"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Season'">
              <span :id="'popover-' + props.row.Season + '-' + stat_table_selected.id" v-b-tooltip.hover title="Click For More">
                {{props.formattedRow[props.column.field]}}
              </span>
              <b-popover
                :target="'popover-' + props.row.Season + '-' + stat_table_selected.id">
                <template slot="title">{{props.row.Name}}</template>
                <ul>
                  <li v-if="$route.query.EntityType == 'Player'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'player' }, query: {Season: props.row.Season, SeasonType: 'Playoffs', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Team'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'team' }, query: {Season: props.row.Season, SeasonType: 'Playoffs', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Opponent'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'opponent' }, query: {Season: props.row.Season, SeasonType: 'Playoffs', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Lineup'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'lineup' }, query: {Season: props.row.Season, SeasonType: 'Playoffs', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'LineupOpponent'"><router-link :to="{ name: 'game_logs', params: { league: $route.params.league, type: 'lineup-opponent' }, query: {Season: props.row.Season, SeasonType: 'Playoffs', EntityId: $route.query.EntityId}}">Game Logs</router-link></li>
                  <li v-if="$route.query.EntityType == 'Team'"><router-link :to="{ name: 'assist_networks', params: { type: 'team', league: $route.params.league }, query: { Season: props.row.Season, SeasonType: 'Playoffs', TeamId: $route.query.EntityId }}">Assist Network</router-link></li>
                  <li v-if="$route.query.EntityType == 'Lineup'"><router-link :to="{ name: 'assist_networks', params: { type: 'lineup', league: $route.params.league }, query: { Season: props.row.Season, SeasonType: 'Playoffs', LineupId: $route.query.EntityId }}">Assist Network</router-link></li>
                </ul>
              </b-popover>
            </div>
            <div v-else>
              <span v-b-tooltip.hover :title="props.formattedRow['Season']">
                {{props.formattedRow[props.column.field]}}
              </span>
            </div>
          </template>
          <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
              {{props.column.label}}
            </span>
            <span v-else>
              {{props.column.label}}
            </span>
          </template>
        </vue-good-table>
        <h5>Playoffs - Career</h5>
        <vue-good-table
          :columns="table_columns[stat_table_selected.id]"
          :rows="[playoff_career_table_data]"
          :sort-options="{ enabled: false}"
          styleClass="vgt-table bordered striped">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.formattedRow[props.column.field] == ''">
              0
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { statTypeOptions } from './mixins/stat_type_options'
import { tableDataOptions } from './mixins/table_data_options'
import { entityStatsBySeasonHeaders } from './mixins/table_headers'
import { tableUtils } from './mixins/table_utils'
import StatTableSelect from './mixins/StatTableSelect.vue'

export default {
  name: 'EntityStatsBySeason',
  components: {
    Multiselect,
    StatTableSelect
  },
  mixins: [rateStats, statTypeOptions, tableDataOptions, entityStatsBySeasonHeaders, tableUtils, StatTableSelect],
  data () {
    return {
      loading: false,
      stat_type_dropdown: {},
      stat_type_selected: undefined,
      table_data_options: [],
      regular_season_table_data: [],
      playoff_table_data: [],
      regular_season_career_table_data: [],
      playoff_career_table_data: [],
      table_columns: {},
      use_min_filters: false,
      use_text_filters: false,
      header: undefined,
      show_error_message: false,
      stat_table_selected: undefined,
      direct_link: '',
      api_endpoint: 'get-all-season-stats/'
    }
  },
  created () {
    this.getStats()
  },
  watch: {
    '$route': 'getStats',
    'stat_table_selected': 'updateDirectLink',
    'stat_type_selected': 'updateDirectLink'
  },
  methods: {
    getStats () {
      this.show_error_message = false
      this.regular_season_table_data = []
      this.playoff_table_data = []
      this.regular_season_career_table_data = []
      this.playoff_career_table_data = []
      this.loading = true
      axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
        params: this.$route.query
      })
        .then((response) => {
          if (!response.data.error) {
            if (this.$route.query.EntityType.toLowerCase() === 'team') {
              var tableColumns = this.team_totals_by_season_header
            } else if (this.$route.query.EntityType.toLowerCase() === 'lineup') {
              tableColumns = this.lineup_totals_by_season_header
            } else {
              tableColumns = this.player_totals_by_season_header
            }
            this.table_columns = tableColumns
            var regularSeasonTotals = response.data.results['Regular Season']
            var careerRegularSeasonTotals = response.data.career_totals['Regular Season']
            var playoffTotals = response.data.results['Playoffs']
            var careerPlayoffTotals = response.data.career_totals['Playoffs']
            if (this.$route.query.EntityType.toLowerCase() === 'player') {
              var tableOptions = this.table_options_with_on_off_and_number_of_fouls
            } else {
              tableOptions = this.base_table_options
            }
            this.table_data_options = tableOptions
            this.stat_type_dropdown = this.options_with_per_game
            this.header = response.data.header

            this.regular_season_table_data.forEach((row) => {
              this.table_data_options.forEach((tableDataOption) => {
                var values = this.setZerosAndSortFunction(this.table_columns[tableDataOption.id], row)
                row = values.row
                this.table_columns[tableDataOption.id] = values.columns
              })
            })

            this.playoff_table_data.forEach((row) => {
              this.table_data_options.forEach((tableDataOption) => {
                var values = this.setZerosAndSortFunction(this.table_columns[tableDataOption.id], row)
                row = values.row
                this.table_columns[tableDataOption.id] = values.columns
              })
            })

            this.regular_season_table_data_totals = regularSeasonTotals
            this.regular_season_table_data_per_100 = this.convertAllRowsToPer100Possessions(response.data.results['Regular Season'], this.table_data_options, this.table_columns)
            this.regular_season_table_data_per_game = this.convertAllRowsToPerGame(response.data.results['Regular Season'], this.table_data_options, this.table_columns)

            this.regular_season_career_totals = careerRegularSeasonTotals
            this.regular_season_career_per_100 = this.convertRowToPer100Possessions(response.data.career_totals['Regular Season'])
            this.regular_season_career_per_game = this.convertRowToPerGame(response.data.career_totals['Regular Season'])

            this.playoff_table_data_totals = playoffTotals
            this.playoff_table_data_per_100 = this.convertAllRowsToPer100Possessions(response.data.results['Playoffs'], this.table_data_options, this.table_columns)
            this.playoff_table_data_per_game = this.convertAllRowsToPerGame(response.data.results['Playoffs'], this.table_data_options, this.table_columns)

            this.playoff_career_totals = careerPlayoffTotals
            this.playoff_career_per_100 = this.convertRowToPer100Possessions(response.data.career_totals['Playoffs'])
            this.playoff_career_per_game = this.convertRowToPerGame(response.data.career_totals['Playoffs'])

            this.setStatTypeValue()
            if (this.stat_type_selected) {
              this.changeStatType()
            }
            if (this.$route.query.Table) {
              this.setStatTableSelected()
            }
            this.loading = false
            this.updateDirectLink()
          } else {
            this.regular_season_table_data = []
            this.regular_season_table_data_totals = []
            this.regular_season_table_data_per_100 = []
            this.regular_season_table_data_per_game = []
            this.regular_season_career_table_data = []
            this.regular_season_career_totals = []
            this.regular_season_career_per_100 = []
            this.regular_season_career_per_game = []
            this.playoff_career_table_data = []
            this.playoff_career_totals = []
            this.playoff_career_per_100 = []
            this.playoff_career_per_game = []
            this.playoff_table_data = []
            this.playoff_table_data_totals = []
            this.playoff_table_data_per_100 = []
            this.playoff_table_data_per_game = []
            this.header = undefined
            this.loading = false
            this.show_error_message = true
          }
        }, (error) => {
          this.show_error_message = true
          this.loading = false
          this.error = error
        })
    },
    setStatTypeValue () {
      this.stat_type_dropdown.data.forEach((statType) => {
        if (statType.id === this.$route.query.StatType) {
          this.stat_type_selected = statType
        }
      })
      if (!this.stat_type_selected) {
        this.stat_type_selected = this.stat_type_dropdown.data[0]
      }
    },
    changeStatType () {
      this.playoff_table_data = {}
      this.regular_season_table_data = {}
      var updatedColumns = {}
      if (this.stat_type_selected.id === 'Totals') {
        this.playoff_table_data = this.playoff_table_data_totals
        this.regular_season_table_data = this.regular_season_table_data_totals
        this.regular_season_career_table_data = this.regular_season_career_totals
        this.playoff_career_table_data = this.playoff_career_totals
        this.table_data_options.forEach((tableDataOption) => {
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.table_columns[tableDataOption.id], 'totals_type')
        })
      } else if (this.stat_type_selected.id === 'Per100Possessions') {
        this.playoff_table_data = this.playoff_table_data_per_100
        this.regular_season_table_data = this.regular_season_table_data_per_100
        this.regular_season_career_table_data = this.regular_season_career_per_100
        this.playoff_career_table_data = this.playoff_career_per_100
        this.table_data_options.forEach((tableDataOption) => {
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.table_columns[tableDataOption.id], 'per_100_poss_type')
        })
      } else if (this.stat_type_selected.id === 'PerGame') {
        this.playoff_table_data = this.playoff_table_data_per_game
        this.regular_season_table_data = this.regular_season_table_data_per_game
        this.regular_season_career_table_data = this.regular_season_career_per_game
        this.playoff_career_table_data = this.playoff_career_per_game
        this.table_data_options.forEach((tableDataOption) => {
          updatedColumns[tableDataOption.id] = this.changeColumnType(this.table_columns[tableDataOption.id], 'per_game_type')
        })
      }
      this.multi_row_table_columns = updatedColumns
    },
    copyDirectLink: function () {
      this.$copyText(this.direct_link)
    },
    updateDirectLink () {
      var query = this.$route.query

      if (this.stat_table_selected) {
        query['Table'] = this.stat_table_selected.id
      }
      if (this.stat_type_selected) {
        query['StatType'] = this.stat_type_selected.id
      }

      var queryString = Object.keys(query).map(function (key) {
        return key + '=' + query[key]
      }).join('&')

      this.direct_link = window.location.origin + this.$route.path + '?' + queryString
    },
    changeColumnType (columns, typeKey) {
      columns.forEach((column) => {
        if (Object.keys(this.rate_stat_details).indexOf(column['field']) > -1) {
          column['type'] = this.rate_stat_details[column['field']][typeKey]
        }
      })
      return columns
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/EntityStatsBySeason.vue